export const objectToQueryParams = (obj) => {
  return Object.keys(obj)
    .map((key) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]);
    })
    .join('&');
};

export const queryParamsToObject = (query) => {
  return query.split('&').reduce((obj, item) => {
    const [key, value] = item.split('=');
    const decodedKey = decodeURIComponent(key);
    const decodedValue = decodeURIComponent(value);
    if (obj[decodedKey]) {
      if (Array.isArray(obj[decodedKey])) {
        obj[decodedKey] = [...obj[decodedKey], decodedValue];
      } else {
        obj[decodedKey] = [obj[decodedKey], decodedValue];
      }
    } else {
      obj[decodedKey] = decodedValue;
    }
    return obj;
  }, {});
};
